import { useEffect, useRef } from 'react'
import { Divider, Icon, Text, Tooltip } from '@stone-payments/jade'
import BlackBird from 'shared/blackbird'

import { type TeamRoleBar } from '~/domains/home-v2/types'

import analitica from '../analitica'

function renderBoldText(text: string) {
  return text.split(/\*\*?(.+?)\*\*?/g).map((part, index) =>
    index % 2 === 1 ? (
      <strong key={index} className="font-semibold">
        {part}
      </strong>
    ) : (
      part
    )
  )
}

export function TeamRoleBar({ teamRoleBar }: { teamRoleBar?: TeamRoleBar }) {
  const hasTrackedView = useRef(false)

  useEffect(() => {
    if (!teamRoleBar?.show || !teamRoleBar.analytics || hasTrackedView.current) return

    hasTrackedView.current = true
    analitica.events.teamRoleBar.viewed(teamRoleBar.analytics)
  }, [teamRoleBar])

  if (!teamRoleBar?.show) return null

  function handleNavigate(bar: TeamRoleBar) {
    if (bar.navigation.analytics) analitica.events.teamRoleBar.clicked(bar.navigation.analytics)

    BlackBird.travelTo(bar.navigation.uri)
  }

  return (
    <>
      <Divider direction="horizontal" size="small" />
      <div data-testid={teamRoleBar.id} className="bg-jade-background-neutral-subtle p-jade-50">
        <div className="relative rounded-jade-xsmall transition-colors duration-200 ease-out hover:bg-jade-background-surface-hover">
          <button
            type="button"
            className="block w-full cursor-pointer rounded-[inherit] border-0 bg-transparent py-jade-100 pl-jade-200 pr-jade-500 text-left"
            onClick={() => handleNavigate(teamRoleBar)}
          >
            <Text variant="text-small" weight="regular" color="high">
              {renderBoldText(teamRoleBar.text)}
            </Text>
          </button>
          <div className="absolute right-jade-200 top-1/2 -translate-y-1/2">
            <Tooltip
              placement="right"
              portal
              text={teamRoleBar.tooltip}
              trigger={
                <button
                  type="button"
                  aria-label="Mais informações sobre a Equipe"
                  className="flex cursor-help border-0 bg-transparent p-0"
                >
                  <Icon size="small" use="circle-info" color="medium" />
                </button>
              }
            />
          </div>
        </div>
      </div>
    </>
  )
}
